import React from 'react';
import { Outlet } from 'react-router';
import { Container } from '@mui/material';
import Footer from '../../footer/footer';
import Header from '../../header/header';
import { useAuth } from '../../../hooks/use-auth.hook';
import { useLocation } from 'react-router-dom';

/**
 * Layout entourant toutes les pages de l'application
 * @constructor
 */
export default function GlobalLayout() {
    //Récupération du contexte
    const auth = useAuth();
    //location
    const location = useLocation();
    const shouldHideHeader = location.pathname === '/' && !auth?.user;
    const authPages = [
        '/reinitialisation-mot-de-passe',
        '/reinitialisation-mot-de-passe/confirmation',
        '/confirmation-changement-email',
    ];
    const isAuthPage = authPages.some(path => location.pathname.startsWith(path));

    /**
     * Permet de savoir si on est en full width
     */
    const isFullWidth = () => {
        const paths = ['premiere-connexion', 'compte', 'contacts', 'ag', 'elu'];
        return (
            paths.some(path => location.pathname.includes(path)) ||
            isAuthPage ||
            (location.pathname === '/' && !auth?.user) ||
            auth?.user?.resetPassword
        );
    };

    // Intégration du header dans les pages
    return (
        <React.Fragment>
            <Container maxWidth={false} className="body-content">
                {!shouldHideHeader && !isAuthPage && (
                    <Header user={auth.user} signoutLoggedInAs={auth.signoutLoggedInAs} signout={auth.signout} />
                )}
                <Container
                    maxWidth={isFullWidth() ? false : 'xl'}
                    sx={{ padding: 0, flex: 1, display: 'flex', flexDirection: 'column' }}
                >
                    <Outlet />
                </Container>
                <Footer />
            </Container>
        </React.Fragment>
    );
}
